const UsedCell = ({ coupon }) => (
    <p className="mb-0 text-muted">
        <span className="fw-semibold text-dark">{coupon.used_count}</span> / <span className="fw-semibold text-dark">{coupon.quota}</span>
    </p>
)

export default UsedCell